import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-learner-jobs-modal',
  templateUrl: './learner-jobs-modal.component.html',
  styleUrls: ['./learner-jobs-modal.component.scss']
})
export class LearnerJobsModalComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
